// extracted by mini-css-extract-plugin
module.exports = {"checkbox__item":"SortCheckbox_checkbox__item__3wgH-"};